import request from "../utils/request";

export function getGiveawayRulesByProductId(productId:number){
    return request.get('/product/giveaway/', {params:{productId}});
}